<template>
    <div class="container">
        <el-form v-if="step === 0" class="form-box" ref="formRef" :model="form" label-width="150px">
            <el-form-item label="个人姓名：" prop="realName" :rules="[{ required: true, message: '请输入个人姓名', trigger: 'blur' }]">
                <el-input v-model="form.realName"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码：" prop="idcardNo" :rules="[{ required: true, message: '请输入身份证号码', trigger: 'blur' }]">
                <el-input v-model="form.idcardNo"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone" :rules="[{ required: true, message: '请输入联系电话', trigger: 'blur' }]">
                <el-input v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item label="联系地址：" prop="address" :rules="[{ required: true, message: '请输入联系地址', trigger: 'blur' }]">
                <el-input v-model="form.address"></el-input>
            </el-form-item>
            <el-form-item v-if="type === 'food'" label="智恒小程序用户ID：" prop="address" :rules="[{ required: true, message: '请输入智恒小程序用户ID', trigger: 'blur' }]">
                <el-input v-model="form.appletUserId"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="nextStep">下一步</el-button>
            </el-form-item>
        </el-form>
        <div v-else-if="step === 1" class="protocol-box">
            <img v-if="type === 'food'" src="https://res.study.itaojin.cn/2024-12/a2db0178b91242aa95dccc40e7bea392.png" alt="">
            <img v-else src="https://res.study.itaojin.cn/2024-12/43abc179e17f495fbc5470878567ac8d.png" alt="">

            <div class="btns">
                <el-button @click="step = step - 1">上一步</el-button>
                <el-button type="primary" :disabled="!!countdown" @click="signContract">
                    <span>去签名</span>
                    <span v-if="countdown">({{countdown}}s)</span>
                </el-button>
            </div>
        </div>
        <div v-else-if="step === 2" class="protocol-box">
            <img :src="dealUrl" alt="">
             <div class="btns" v-if="$route.query.admin">
                <el-button type="primary" @click="step = 0">修 改</el-button>
            </div>
        </div>

        <el-dialog title="请签名" :visible.sync="dialogObj.visible" width="500px" :close-on-click-modal="false">
            <div class="box">
                <vue-esign ref="esign" :width="458" :height="260" :isCrop="false" :lineWidth="3" lineColor="#000" />
            </div>
            <div slot="footer">
                <el-button @click="handleReset">重 写</el-button>
                <el-button type="primary" @click="submitFun" :loading="loading">提交签名</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import vueEsign from '@/components/vueEsign.vue'
    import { iTaojinAppUtil } from '@/utility/iTaojinAppUtil';
    export default {
        components: { vueEsign },
        data() {
            return {
                step: 0,
                form: {
                    realName: '',
                    idcardNo: '',
                    phone: '',
                    address: '',
                    appletUserId: null
                },
                countdown: 0,
                loading: false,
                dialogObj: {
                    visible: false
                },
                dealUrl: null,
                type: null
            }
        },
        mounted() {
            try {
                window.getToken = this.getToken;
                this.initToken();
            } catch(e) {}

            this.type = this.getUrlParam('type')
            this.getCustomerInfo()
        },
        methods: {
            initToken() {
                let result = iTaojinAppUtil.callNativeFun('getNativeToken');
                if (result.data != null) {
                    document.cookie = 'login_token=' + result.data + ';'
                }
            },

            //ios调用传入token
            getToken(token) {
                document.cookie = 'login_token=' + token + ';'
            },
            
            getUrlParam(name) {
                let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)")
                let r = (window.location.search || window.location.hash).match(reg)
                if (r != null) return r[2]
                return null
            },

            getCustomerInfo() {
                this.$http.post(API_ROOT.college + '/gzhArticalSign/queryByTjkId?type=' + this.type).then(response => {
                    var result = response.data
                    if (result.success) {
                        this.form = result.data || {}
                        this.dealUrl = result.data.dealUrl
                        this.step = this.dealUrl ? 2 : 0
                    } else {
                        this.$alert(result.message || result.msg)
                    }
                }, err => {
                    this.$alert('网络繁忙，请稍后重试！')
                })
            },

            nextStep() {
                if (!this.form.idcardNo) {
                    this.$alert('无实名认证信息！')
                    return
                }
                this.$refs.formRef.validate((valid) => {
                    if(!valid) {
                        return
                    }
                    this.step += 1
                    this.countdown = 10
                    this.interval && clearInterval(this.interval)
                    this.interval = setInterval(() => {
                        this.countdown -= 1
                        if (this.countdown <= 0) {
                            clearInterval(this.interval)
                        }
                    }, 1000)
                })
            },

            handleReset() {
                this.$refs.esign.reset()
            },

            signContract() {
                this.$refs.esign?.reset()
                this.dialogObj.visible = true
                this.loading = false
            },

            submitFun() {
                this.loading = true
                this.$refs.esign.generate({ format: "png", quality: 0.8 }).then(res => {
                    const blob = this.dataURLtoBlob(res)
                    const file = this.blobToFile(blob, '签名.png')
                    this.customUpload(file).then(imgUrl => {
                        let data = {
                            signUrl: imgUrl,
                            address: this.form.address,
                            appletUserId: this.form.appletUserId,
                            realName: this.form.realName,
                            idcardNo: this.form.idcardNo,
                            phone: this.form.phone,
                            type: this.type
                        }
                        this.$http.post(API_ROOT.college + '/gzhArticalSign/addSign', data).then(response => {
                            var result = response.data
                            this.loading = false
                            if (result.success) {
                                this.dialogObj.visible = false
                                this.$message.success('签约成功');
                                this.getCustomerInfo()
                            } else {
                                this.$alert(result.message || result.msg)
                            }
                        }, err => {
                            this.loading = false
                            this.$alert('网络繁忙，请稍后重试！')
                        })
                    }, () => {
                        this.loading = false
                    })
                }).catch(err => {
                    this.loading = false
                    this.$alert("生成图片失败：" + err.message);
                })
            },

            dataURLtoBlob(dataurl) {
                let arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], { type: mime });
            },

            blobToFile(theBlob, fileName) {
                theBlob.lastModifiedDate = new Date();
                theBlob.name = fileName;
                return theBlob;
            },

            getQiniuConfig(file) {
                return new Promise((resolve, reject) => {
                    const fileName = file.name
                    const data = {
                        ext: fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length)
                    }
                    this.$http.post(API_ROOT.method + '/qiniu/token', data).then(res => {
                        var res = res.data
                        if( res.success ) {
                            resolve(res.data)
                        } else {
                            this.$alert('上传图片失败!', '警告')
                            reject()
                        }
                    }, err => {
                        this.$alert('上传图片失败!', '警告')
                        reject()
                    })
                })
            },

            customUpload(file) {
                return new Promise((resolve, reject) => {
                    this.getQiniuConfig(file).then(config => {
                        const formdata = new FormData()
                        formdata.append('file', file)
                        formdata.append('token', config.token)
                        formdata.append('key', config.key)

                        this.$http.post('//upload-z0.qiniup.com', formdata, {
                            headers: {'Content-Type': 'multipart/form-data'}
                        }).then(res => {
                            resolve(config.domain + '/' + res.data.key)
                        }, err => {
                            this.$alert('上传图片失败!', '警告')
                            reject()
                        })
                    }, err => {
                        reject()
                    })
                })
            }
        }
    }
</script>

<style>
.container{
    width: min(100%, 800px);
    margin: auto;
    padding: 1px;
}
.form-box {
    width: 500px;
    margin: 50px auto;
}
.protocol-box {
    img {
        display: block;
        max-width: 100%;
        margin: auto;
    }
    .btns {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 50px;
    }
}
.box {
    margin-top: -20px;
    border: 1px solid #ccc;
}
</style>


// WEBPACK FOOTER //
// ./src/page/signContract.vue